export function get_sub_section_list(section) {
  let sub_section_list = [], sub_section_list2
  if (section.type === 'section') {
    sub_section_list.push(section)
    if (section.children && section.children.length > 0) {
      section.children.forEach(item => {
        sub_section_list2 = get_sub_section_list(item)
        if (sub_section_list2.length > 0) {
          sub_section_list = sub_section_list.concat(sub_section_list2)
        }
      })
    }
  }

  return sub_section_list
}

// 过滤出所有的段，返回段列表
export function filterSection(nodes) {
  let section_list = [], section_list2 = []
  if (!nodes || nodes.length === 0) return []
  nodes.forEach(node => {
    if (node.type === 'section') {   // 这是一个段
      section_list.push(node)
      if (node.children && node.children.length > 0) {
        section_list2 = filterSection(node.children)
        if (section_list2 && section_list2.length > 0) {
          section_list = section_list.concat(section_list2)
        }
      }
    }
  })

  return section_list
}

// 过滤出所有的条款，返回条款列表
export function filterClause(nodes) {
  let clause_list = [], clause_list2 = []
  if (!nodes || nodes.length === 0) return []
  nodes.forEach(node => {
    if (node.type === 'clause') {   // 这是一个条款
      clause_list.push(node)
    } else if (node.children && node.children.length > 0) {
      clause_list2 = filterClause(node.children)
      if (clause_list2 && clause_list2.length > 0) {
        clause_list = clause_list.concat(clause_list2)
      }
    }
  })

  return clause_list
}

// 判断方案中是否已经存在包含此代码的子段或者条款
export function filterNode(nodes, node) {
  if (!nodes || !node || !node.code || !node.type) return undefined
  let have_node = nodes.find(n => {
    if (n.code === node.code && n.type === node.type) {
      return true
    } else if (n.children && n.children.length > 0) {   // n为段，并且有子段或条款
      return filterNode(n.children, node)
    } else {
      return false
    }
  })

  return have_node
}

export function variable_replace(clause) {
  let new_content = clause.content.replace(/{([\w|_][\w|_|\d]+)}/g, function ($0, $1) {
    let variable = clause.variables.find(item => {
      return (item.code === $1)
    })

    let def_value = $0
    if (variable !== undefined) {
      if (variable.value >= 10000) {
        def_value = parseInt(variable.value) / 10000 + '万'
      } else if (variable.value < 1 && variable.value > 0) {
        def_value = parseFloat((variable.value * 100).toPrecision(12)) + '%'
      } else {
        def_value = parseFloat(variable.value) + ''
      }
    }

    // return "<span style='color: red; font-weight: bold;'>" + def_value + "</span>"
    return def_value
  })

  return new_content
}

export function gen_content(scheme) {
  let content = ''
  scheme.children.forEach((section, section_index) => {
    let seq
    if (scheme.list_seq === 1) {
      seq = (section_index + 1) + '、'
    } else if (scheme.list_seq === 2) {
      seq = (section_index + 1) + '）'
    } else {
      seq = ''
    }

    if (scheme.children.length === 1) {
      seq = ''
    }

    if (section.content) {
      if (section.children) {
        if (section.children.length === 1) {
          content += seq + section.content + ': '
        } else if (section.children.length > 1) {
          content += seq + section.content + ': \n'
        }
      } else if (section.type === 'clause') {
        section.content = variable_replace(section)
        content += seq + section.content + '\n'
      } else {
        content += seq + section.content + '\n'
      }
    }

    if (section.children && section.children.length > 0) {
      content += gen_content(section) + '\n'
    }
  })

  return content
}

export function filterCheckedNode(node) {
  if(node.type === 'section') {
    if(node.children && node.children.length > 0) {
      node.children = node.children.filter(child => {
        return filterCheckedNode(child)
      })
    }
    return ((node.checked || node.indeterminate) && node.children && node.children.length > 0) ? true : false
  } else if(node.type === 'clause') {
    return node.checked ? true : false
  } else {
    return false
  }
}

// 过滤出所有的条款，返回条款列表
export function filterCheckedClause(nodes) {
  let clause_list = [], clause_list2 = []
  if (!nodes || nodes.length === 0) return []
  nodes.forEach(node => {
    if (node.type === 'clause' && node.checked) {   // 这是一个条款
      clause_list.push(node)
    } else if (node.children && node.children.length > 0) {
      clause_list2 = filterCheckedClause(node.children)
      if (clause_list2 && clause_list2.length > 0) {
        clause_list = clause_list.concat(clause_list2)
      }
    }
  })

  return clause_list
}

export function filterCheckedKeys(nodes) {
  let key_list = [], key_list2 = []
  if (!nodes || nodes.length === 0) return []
  nodes.forEach(node => {
    if (node.type === 'clause' && node.checked) {   // 这是一个条款
      key_list.push(node.id)
    } else if (node.children && node.children.length > 0) {
      key_list2 = filterCheckedKeys(node.children)
      if (key_list2 && key_list2.length > 0) {
        key_list = key_list.concat(key_list2)
      }
    }
  })

  return key_list
}

export function getSpecialAgreementContent(scheme) {
  let temp_scheme = JSON.parse(JSON.stringify(scheme.adjusted_content))
  let special_agreement_section = temp_scheme.find(section => {
    return (section.code === 'special_agreement')
  })
  if (!special_agreement_section) {
    return ''
  }
  special_agreement_section.children = special_agreement_section.children.filter(section => {
    return filterCheckedNode(section)
  })
  let content = gen_content(special_agreement_section)
  return content
}